import { PDFDocument } from "pdf-lib";

export class LogisticDocumentPdfContent {
    public content: PDFDocument | undefined;
    public error: Error | undefined;
}